/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import useLogOutSectionModals from "src/components/organisms/LogOutSection/useLogOutSectionModals";
import { useLogoutUserAction } from "src/store/login/hooks/useActions";
import Account from "./Account";
import { useIsImpersonating } from "../../../../../store/impersonation/useSelectors";
import { FeedbackModal } from "../../../../molecules/modals/FeedbackModal";
import { useBooleanState } from "../../../../../hooks/utils";
import { useInvokeBugReportModalCallback } from "../../../../../store/bugReport/useActions";
import { BugModalInvoker } from "../../../../../store/bugReport/types";
import {
  useHasFlowioAnyBugs,
  useUnreportedBugsCount,
} from "../../../../../store/bugReport/useSelectors";

const { NavMenu } = BugModalInvoker;

const Container: FC = () => {
  const isImpersonating = useIsImpersonating();
  const requestLogout = useLogoutUserAction();
  const [feedbackModalOpen, toggleFeedbackModal] = useBooleanState(false);
  const invokeBugReportModal = useInvokeBugReportModalCallback(NavMenu);
  const unreportedBugsCount = useUnreportedBugsCount();
  const hasFlowioBugs = useHasFlowioAnyBugs();

  const { modals, setIsPasswordModalOpen, setIsBugsModalOpen } =
    useLogOutSectionModals(requestLogout);
  return (
    <Fragment>
      <FeedbackModal
        isOpen={feedbackModalOpen}
        toggleOpen={toggleFeedbackModal}
      />
      {modals}
      <Account
        isImpersonating={!!isImpersonating}
        unreportedBugsCount={unreportedBugsCount}
        hasFlowioBugs={hasFlowioBugs}
        invokeBugReportModal={invokeBugReportModal}
        invokeBugOverviewModal={setIsBugsModalOpen}
        invokeFeedbackModal={toggleFeedbackModal}
        invokePasswordChangeModal={setIsPasswordModalOpen}
      />
    </Fragment>
  );
};

export default Container;
